import React from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import NexusNodesBasicInfoComponent from './nexus-node-basic-info.component';
import NexusNodeTypesAddresComponent from './nexus-node-address-component';

export const NexusNodesComponent = ({ handleInnerFormChange,GlobalNexusZone,NexusNodeType,queryItems,NexusZoneId, selectedNexusNodes, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Nexus-Nodes Details',
      component: <NexusNodesBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedNexusNodes={selectedNexusNodes}
        queryItems={queryItems}
        NexusZoneId={NexusZoneId}
        NexusNodeType={NexusNodeType}
        GlobalNexusZone={GlobalNexusZone}
      />,
      isVisible: true,
    },
     {
      id: 1,
      title: 'Address',
      component: <NexusNodeTypesAddresComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedNexusNodes={selectedNexusNodes}
        queryItems={queryItems}
        NexusZoneId={NexusZoneId}
        NexusNodeType={NexusNodeType}
        GlobalNexusZone={GlobalNexusZone}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default NexusNodesComponent;
